import React, { Component } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { formatPhoneNumberForUi } from '../../utils/formatNumber';

class DialogPhoneField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: formatPhoneNumberForUi(props.value)
        };
    }
    handlePhoneNumberChange = (event) => {
        this.props.onChange(this.props.field.id, event.target.value);
        this.setState({ value: event.target.value });
    };
    render() {
        return (
            <TextField
                label="Phone Number"
                variant="outlined"
                margin="dense"
                fullWidth
                value={this.state.value}
                onChange={this.handlePhoneNumberChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <PhoneIcon />
                        </InputAdornment>
                    )
                }}
            />
        );
    }
}

export default DialogPhoneField;
